<template>
  <!-- eslint-disable -->
  <div class="eggos-wrapper">
    <svg xmlns="http://www.w3.org/2000/svg" width="711.059" height="560.11" viewBox="0 0 711.059 560.11">
      <g id="bgpattern" transform="translate(-64.25 39.332)" class="fill-current" :class="[`text-${color}`]">
        <path id="Path_13" d="M641.859-39.332c-73.708,0-133.453,59.39-133.453,132.668s59.745,132.68,133.453,132.68,133.45-59.4,133.45-132.68S715.559-39.332,641.859-39.332" />
        <path id="Path_14" d="M197.7-39.332C124-39.332,64.25,20.058,64.25,93.336S124,226.016,197.7,226.016s133.449-59.4,133.449-132.68S271.4-39.332,197.7-39.332" />
        <path id="Path_15" d="M197.7,255.429C124,255.429,64.25,314.819,64.25,388.1S124,520.778,197.7,520.778s133.449-59.4,133.449-132.68S271.4,255.429,197.7,255.429" />
        <path id="Path_16" d="M419.946,108.082a58.967,58.967,0,1,0,59.307,58.966,59.136,59.136,0,0,0-59.307-58.966" />
        <path id="Path_17" d="M419.946-39.332a59.136,59.136,0,0,0-59.31,58.966,59.309,59.309,0,0,0,118.617,0,59.134,59.134,0,0,0-59.307-58.966" />
        <path id="Path_18" d="M567.02,374.053c113.987,0,206.387-26.552,206.387-59.309s-92.4-59.315-206.387-59.315-206.384,26.56-206.384,59.315,92.4,59.309,206.384,59.309" />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Eggos',

  props: {
    color: {
      type: String,
      default: 'grey',
    },
  },
};
</script>

<style scoped lang="scss">
  .eggos-wrapper {
    @apply hidden fixed;
    z-index: 0;
    right: -200px;
    bottom: -220px;
    @media screen and (min-width: 768px) {
      @apply block;
    }
  }
</style>
